import { useStore } from "../store";

/**
 * Plan/entitlements hook — the single client-side source for what the current
 * tenant can do. Data comes from GET /entitlements (loaded into the store on
 * app mount); the backend remains the real enforcement point.
 *
 *   const { plan, isTrial, canBulkImport, candidates, atCandidateLimit } = usePlan();
 */
export function usePlan() {
  const e = useStore((s) => s.entitlements);
  const f = e?.features || {};
  const usage = (k) => e?.[k] || { used: 0, max: null };

  const candidates = usage("candidates");
  const seats = usage("seats");

  const atLimit = (u) => u.max != null && u.used >= u.max;

  return {
    entitlements: e,
    loaded: !!e,
    plan: e?.plan || "Trial",
    isTrial: e ? !!e.isTrial : true,
    isPro: !!e?.isPro,
    isEnterprise: !!e?.isEnterprise,
    // True once Stripe has issued a customer id (real checkout happened). Admin-granted
    // plans leave this false → the UI offers a checkout instead of a dead "manage" link.
    hasBillingAccount: !!e?.hasBillingAccount,

    // Feature flags (mirror VeftPlanLimitationsService)
    canBulkImport: !!f.bulk_import,
    canUseCustomTemplates: !!f.custom_templates,
    canAccessApi: !!f.api_access,
    canUseChat: !!f.ai_chat,
    canBuyCredits: !!f.buy_credits,
    canUseConsent: !!f.gdpr_consent,
    canUseCollaboration: !!f.collaboration,

    // Numeric limits + live usage ({ used, max } — max null = unlimited).
    // No activeProjects here: project status is an organizational label, not a
    // billing axis (PLANS/Veft/pricing-and-segmentation-2026-06-30.md).
    candidates,
    seats,
    atCandidateLimit: atLimit(candidates),
    atSeatLimit: atLimit(seats),

    creditsBalance: e?.creditsBalance ?? 0,
  };
}
